<template>
	<div>
		<Layout :back="'/'" class="bg-primary " :navTransparent="true">
			<template slot="header">
				<h1>Historial de ventas</h1>
				<!-- <p>¡Registrá tus ventas y sumá puntos!</p> -->
			</template>

			<div class="main-container p-4">
				<div v-for="item in list" :key="item.id" class="sell">
					<div class="image">
						<img :src="item.products[0].product.image" class="img-fluid" />
					</div>
					<div class="data">
						<h2>{{ item.products[0].product.name }}</h2>
						<p>{{ item.createdAt | moment('DD-MM-YYYY') }}</p>
					</div>
					<div class="points">
						{{ item.points }}
						<div class="label">PTS</div>
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import Layout from '@/components/layout/Layout'

export default {
	name: 'SellHistory',
	components: {
		Layout,
	},
	data() {
		return {
			list: [],
			loading: true,
		}
	},

	async beforeMount() {
		this.loading = true
		await this.load()
		this.loading = false
	},

	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query {
							sells {
								data {
									id
									points
									createdAt
									products {
										product {
											id
											name
											image
										}
									}
								}
							}
						}
					`,
					fetchPolicy: 'no-cache',
				})
				.then(({ data }) => {
					this.list = data.sells.data
					this.loading = false
				})
		},
	},
}
</script>

<style scoped>
.main-container {
	background-color: #fff;
	border-radius: 24px 0px 0px 0px;
}

.sell {
	display: flex;
	align-items: center;
	border-bottom: 1px solid #f1f1f1;
	padding: 4px 0px;
}
.sell .image {
	width: 64px;
	flex-shrink: 0;
}
.sell .data {
	flex-grow: 1;
	padding: 2px 8px;
}
.sell .data h2 {
	font-size: 14px;
	font-weight: 600;
	margin: 0px;
}
.sell .data p {
	font-size: 12px;
	color: #8f8f8f;
	margin: 0px;
}
.sell .points {
	text-align: right;
	font-size: 16px;
	font-weight: 600;
}
.label {
	color: #8f8f8f;
}
</style>
